define((require) => {
    "use strict";

    var EditorEvents               = require("shared/services/EditorEvents"),
        ImprovedView               = require("editor/zbone/ImprovedView"),
        Ladda                      = require("ladda"),
        NavBarCurrentPrincipalView = require("ui/common/NavBarCurrentPrincipalView"),
        Permissions                = require("shared/security/Permissions"),
        SyncManager                = require("shared/services/sync/SyncManager"),
        template                   = require("ui/common/NavBarView.tpl");
    const Storage                  = require("shared/services/Storage");
    /**
     * The navigation bar view.
     *
     * @class NavBarView
     * @constructor
     *
     * @cfg {Principal} [principal] The current logged in principal. If specified, the nav bar options related to
     *                              the current principal (and associated user) are displayed.
     */
    return ImprovedView.extend({
        /**
         * @private @type {Ladda}
         * Spinner activated while global sync(s) is (are) pending. <p>
         */
        _spinner: null,

        _currentPrincipalView: null,

        _currentProject: null,

        template: template,

        templateHelpers: function() {
            var currentProjectName = this._currentProject ? this._currentProject.get("name") : "",
                currentProjectId = this._currentProject ? this._currentProject.get("id") : "";

            return {
                currentProject: this._currentProject,
                currentProjectName: currentProjectName,
                currentProjectId: currentProjectId,
                spectator: this.spectatorMode,
                contentControlBetaEnabled: Storage.Local.get(Storage.Keys.CONTENT_CONTROL_BETA, Storage.Keys.CONTENT_CONTROL_BETA),
                newDashboardExperience: Storage.Local.get(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP)
            };
        },

        regions: {
            currentPrincipal: ".current-principal"
        },

        ui: {
            logo: ".logo",
            projectSelectorBtn: ".project-selector-btn",
            projectContextBtn: ".project-context-btn",
            spinner: ".spinner"
        },

        events: {
            "click @ui.logo": "_trackEditorEvent",
            "click @ui.projectSelectorBtn": "_handleProjectSelectorBtnClick",
            "click @ui.projectContextBtn": "_handleProjectContextClick"
        },

        viewScope: function() {
            return {
                viewModel: this.options.viewModel
            };
        },

        _handleProjectSelectorBtnClick: function() {
            this.toggleProjectPanel();

            var eventProperties = {
                projectId: this._currentProject && this._currentProject.get("id"),
                triggerOrigin: "ProjectSelectorButton"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_PROJECT_SELECTOR, eventProperties);
        },

        _handleProjectContextClick: function() {
            var eventProperties = {
                dashboardType: "Experiences",
                projectId: this._currentProject && this._currentProject.get("id"),
                triggerOrigin: "DashboardTab"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_DASHBOARD, eventProperties);
        },

        toggleProjectPanel: function() {
            this.viewScope.toggleProjectSelector();
        },

        _toggleSync: function(syncing) {
            if (this._spinner) {
                if (syncing) {
                    this._spinner.start();
                } else {
                    this._spinner.stop(0); // stop with 0 delay, we know this event is already delay a bit...
                }
            }
        },

        initialize: function(options) {
            var experienceId;
            if (this.model) {
                experienceId = this.model.get("id");
            }
            
            //on coming to legacy dashboard set the key to false.
            if (window.location.hash.split("/") == 0) {
                Storage.Local.update(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP, false);
            }

            this._currentPrincipalView = new NavBarCurrentPrincipalView({
                model: options.principal,
                project: this._currentProject,
                experienceId: experienceId
            });

            this._currentProject = this.options.project;

            if (this._currentProject) {
                this.listenTo(this._currentProject, "change:name", function(model, value) {
                    this.ui.projectContextBtn.text(value);
                });
            }

            this.spectatorMode = Permissions.Privileges.CREATE.cannot();
        },

        onRender: function() {
            if (this.options.principal) {
                this.currentPrincipal.show(this._currentPrincipalView);
            }

            // Create global spinner...
            if (this.ui.spinner.length) {
                this._spinner = Ladda.create(this.ui.spinner[0]);
                this.listenTo(SyncManager, "syncing", this._toggleSync.bind(this));
                // Set initial state...
                this._toggleSync(SyncManager.syncing());
            }
        },

        onClose: function() {
            this._toggleSync(false);
        },

        /**
         * Tracks Mix Panel event when clicking the Creator logo.
         * @private
         */
        _trackEditorEvent: function() {
            var eventProperties = {
                projectId: this._currentProject && this._currentProject.get("id"),
                dashboardType: "Experiences",
                triggerOrigin: "CreatorLogoLink"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_DASHBOARD, eventProperties);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/NavBarView.js